export const SET_AUTH = 'SET_AUTH'
export const SET_CUSTOMERS_LIST = 'SET_CUSTOMERS_LIST'
export const SET_CUSTOMER = 'SET_CUSTOMER'
export const CLEAR_AUTH = 'CLEAR_AUTH'
